













import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ProgressBar extends Vue {
  @Prop({ required: true })
  public progress;
  @Prop({ default: false })
  public hasError;

  public get width() {
    return `width: ${this.progress}%;`;
  }
}
